export default "__VITE_ASSET__1275f3fc__"